import * as React from 'react';

import { PersistZone, Remote, Stores } from '@pitaman71/omniglot-live-data';

import { Propose } from '.';

const __moduleName__ = '@pitaman71/omniglot-live-react.Database';

export const Context = React.createContext<{ 
    zone?: Stores.Zone
}>({ 
 });

export function Provide(props: React.PropsWithChildren<{
    persistServiceURI: string
}>) {
    const [ persistZone, setPersistZone ] = React.useState<PersistZone.PersistZone>();
    React.useEffect(() => {
        setPersistZone(new PersistZone.PersistZone(new Remote.Client((url, args) => window.fetch(url, args), props.persistServiceURI)));
    }, [window.fetch]);
    return (
        <Context.Provider value={{ zone: persistZone }}>
            {props.children}
        </Context.Provider>
    )
}

function _AsEditor(props: {
    zone: Stores.Zone,
    peerId: string,
    pollInterval: { ms: number },
    render: (proposeZone: Stores.Zone) => JSX.Element
}) {
    const context = React.useContext(Context);
    return Propose.withProposal(props.peerId, props.zone, props.pollInterval, (proposeZone) => (
        <Context.Provider value={{ ...context, zone: proposeZone }}>
            { props.render(proposeZone) }
        </Context.Provider>
    ));
}

export function AsEditor(props: {
    peerId: string,
    pollInterval: { ms: number },
    render: (proposeZone: Stores.Zone) => JSX.Element
}) {
    const { zone } = React.useContext(Context);
    return !zone ? <React.Fragment></React.Fragment> : <_AsEditor {...props} zone={zone}/>
}

export function AsViewer(props: {
    render: (proposeZone: Stores.Zone) => JSX.Element
}) {
    const { zone } = React.useContext(Context);
    return !zone ? <React.Fragment></React.Fragment> : props.render(zone);
}

